/**
 * @author      yontaek@zumper.com (Yon Taek Chung)
 * @copyright   Copyright (c) 2019, Zumper
 * @description PreserveFiltersLink Container
 */

import PreserveFiltersLink from '@zcode/nr/es/shared/components/PreserveFiltersLink'
import pushUrlWithFilters from '@zcode/nr/es/shared/components/PreserveFiltersLink/thunks/pushUrlWithFilters'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { selectFilters } from '../../modules/filters/selectors/index'

const mapDispatchToProps = (dispatch, ownProps) => ({
  onClick: (e) => {
    e.preventDefault()
    e.stopPropagation()

    const { onClick, resetHousingType, to } = ownProps
    onClick && onClick(e)

    dispatch((_, getState) => {
      const state = getState()
      const filters = selectFilters(state)
      dispatch(
        pushUrlWithFilters({
          event: e,
          filters,
          isZumperFilters: true,
          resetHousingType,
          to,
        })
      )
    })
  },
})

PreserveFiltersLink.propTypes = {
  onClick: PropTypes.func,
  resetHousingType: PropTypes.bool,
  to: PropTypes.string.isRequired,
}

const PreserveFiltersLinkContainer = connect(null, mapDispatchToProps)(PreserveFiltersLink)

export default PreserveFiltersLinkContainer
